type SessionExpiredHandler = (message?: string) => void;
type GlobalNoticeHandler = (message: string) => void;

const LOGIN_NOTICE_KEY = "iec62443_login_notice";
let sessionExpiredHandler: SessionExpiredHandler | null = null;
let globalNoticeHandler: GlobalNoticeHandler | null = null;

export function registerSessionExpiredHandler(handler: SessionExpiredHandler | null) {
  sessionExpiredHandler = handler;
}

export function notifySessionExpired(message?: string) {
  if (sessionExpiredHandler) {
    sessionExpiredHandler(message);
  }
}

export function registerGlobalNoticeHandler(handler: GlobalNoticeHandler | null) {
  globalNoticeHandler = handler;
}

export function notifyGlobalNotice(message: string) {
  if (globalNoticeHandler) {
    globalNoticeHandler(message);
  }
}

export function storeLoginNotice(message: string) {
  try {
    sessionStorage.setItem(LOGIN_NOTICE_KEY, message);
  } catch {
    // ignore storage issues
  }
}

export function consumeLoginNotice(): string | null {
  try {
    const msg = sessionStorage.getItem(LOGIN_NOTICE_KEY);
    if (msg != null) {
      sessionStorage.removeItem(LOGIN_NOTICE_KEY);
      return msg;
    }
    return null;
  } catch {
    return null;
  }
}
